import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { 
  listAccompanyShoppingReviews,
  getAccompanyShoppingReviewById,
  deleteAccompanyShoppingReview
} from '../../api/accompanyShoppingReview';

// 匿名状态映射
export const ANONYMOUS_STATUS_MAP = {
  0: '实名',
  1: '匿名'
};

// 分页查询陪逛服务评价的异步 thunk
export const fetchAccompanyShoppingReviews = createAsyncThunk(
  'accompanyShoppingReview/fetchReviews',
  async (params, { rejectWithValue }) => {
    try {
      const response = await listAccompanyShoppingReviews(params);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

// 获取单个陪逛服务评价详情的异步 thunk
export const fetchAccompanyShoppingReviewDetail = createAsyncThunk(
  'accompanyShoppingReview/fetchReviewDetail',
  async (id, { rejectWithValue }) => {
    try {
      const response = await getAccompanyShoppingReviewById(id);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

// 删除陪逛服务评价的异步 thunk
export const deleteReview = createAsyncThunk(
  'accompanyShoppingReview/deleteReview',
  async (id, { rejectWithValue }) => {
    try {
      await deleteAccompanyShoppingReview(id);
      return id;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const accompanyShoppingReviewSlice = createSlice({
  name: 'accompanyShoppingReview',
  initialState: {
    reviews: [],
    total: 0,
    current: 1,
    pageSize: 10,
    currentReview: null,
    loading: false,
    error: null
  },
  reducers: {},
  extraReducers: (builder) => {
    // 处理分页查询陪逛服务评价的 reducer
    builder.addCase(fetchAccompanyShoppingReviews.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(fetchAccompanyShoppingReviews.fulfilled, (state, action) => {
      state.loading = false;
      state.reviews = action.payload.records || [];
      state.total = action.payload.total || 0;
      state.current = action.payload.current || 1;
      state.pageSize = action.payload.size || 10;
    });
    builder.addCase(fetchAccompanyShoppingReviews.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    // 处理获取评价详情的 reducer
    builder.addCase(fetchAccompanyShoppingReviewDetail.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(fetchAccompanyShoppingReviewDetail.fulfilled, (state, action) => {
      state.loading = false;
      state.currentReview = action.payload;
    });
    builder.addCase(fetchAccompanyShoppingReviewDetail.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    // 处理删除评价的 reducer
    builder.addCase(deleteReview.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(deleteReview.fulfilled, (state, action) => {
      state.loading = false;
      // 从列表中移除已删除的评价
      state.reviews = state.reviews.filter(review => review.id !== action.payload);
      state.total -= 1;
    });
    builder.addCase(deleteReview.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
  }
});

export default accompanyShoppingReviewSlice.reducer; 